<template>
  <div>
    <section class="section">
      <card-component
        class="has-table is-fullwidth"
        title="Permission List"
        icon="shield-check"
      >
        <template #headerRight>
          <router-link slot="right" to="permission/create">
            <b-button type="is-primary" icon-left="plus" size="is-small">
              Register Permission
            </b-button>
          </router-link>
        </template>
        <fl-table
          is-paginated
          namespace="permission"
          title-key="name"
          :columns="permissionColumns"
          :service="service"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { read as readPermission, del as deletePermission } from '@/api/permission'

import FlTable from '@/components/table/FlTable'

export default {
  name: 'ReadPermission',
  components: { FlTable },
  data() {
    const permissionColumns = [
      {
        label: 'Method',
        key: 'method'
      },
      {
        label: 'Module',
        key: 'module'
      },
      {
        label: 'Description',
        key: 'description'
      }
    ]

    return {
      permissionColumns,
      service: {
        read: readPermission,
        delete: deletePermission
      }
    }
  }
}
</script>
